import { React } from 'Imports';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WidgetTooltip } from '$Components/Shared/WidgetTooltip';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

const styles = require('../styles/ConnectionStatusTooltip.scss') as {
    descriptionText: string;
    iconColor: string;
};

interface IConnectionStatusTooltipProps {
    hoverTooltipDisabled?: boolean;
}

type ConnectionStatusTooltipProps = IConnectionStatusTooltipProps;

export const ConnectionStatusTooltip = (props: ConnectionStatusTooltipProps) => {
    return (
        <WidgetTooltip
            prompt={<FontAwesomeIcon icon={faInfoCircle} className={styles.iconColor} />}
            description={
                <div className={styles.descriptionText}>
                    Connection Status indicates if there is no power going to the camera; <strong>Online</strong> - Vehicle is powered on,
                    camera has power to it, and has a network connection, <strong> Offline</strong> - Vehicle may be powered off; camera may
                    not be plugged in; network issues may be preventing the camera from connection to the server. Date/time indicate when
                    the camera came Online or became Offline.
                </div>
            }
            contentPositionRight="-12px"
            contentPosition="bottomRight"
            hoverTooltipDisabled={props.hoverTooltipDisabled}
        />
    );
};
